import { useSearchParams } from "next/navigation"

export const useJobAdsSearchParams = (): URLSearchParams => {
  const readOnlySearchParams = useSearchParams()
  const searchParams = new URLSearchParams(readOnlySearchParams)

  for (const [key, value] of readOnlySearchParams.entries()) {
    if (!value) {
      // delete method functionaly working but the type not working properly : https://github.com/microsoft/TypeScript-DOM-lib-generator?tab=readme-ov-file#when-the-type-is-missing
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      searchParams.delete(key, value)
    }
  }

  return searchParams
}
